import { Container } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing, purpurMedia } from '@telialt/common-theme/src/purpurSelectors';

type CenteredProps = {
    $isCentered?: boolean;
};

export const ContentTitleContainer = styled(Container)<CenteredProps>`
    display: flex;
    flex-direction: column;
    gap: ${getPurpurSpacing('150')};
    margin-top: ${getPurpurSpacing('600')};

    ${purpurMedia('lg')`
        gap: ${getPurpurSpacing('250')};
        margin-top: ${getPurpurSpacing('800')};
    `};

    ${({ $isCentered }) =>
        $isCentered &&
        purpurMedia('lg')`
        text-align: center;
    `};
`;
